import 'react';
import { Announce } from './Announce.js';
import { jsx } from 'react/jsx-runtime';

function AriaStatus({
  announceOnShow = false,
  children,
  ...rest
}) {
  return /*#__PURE__*/jsx(Announce, {
    ...rest,
    announceOnShow: announceOnShow,
    politeness: "polite",
    children: children
  });
}
AriaStatus.displayName = "AriaStatus";

export { AriaStatus };
